import { Phone, Mail, MapPin } from "lucide-react";
import { FaXTwitter, FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="bg-wl-navy text-white py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Company Card */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 mb-8">
          <h3 className="text-2xl font-bold text-white mb-2">Whitefield Legal Services</h3>
          <hr className="border-white/20 mb-4" />
          <p className="text-white/80 text-sm">
            Independent company providing conveyancing searches for 20 years nationally and locally.
          </p>
        </div>
        
        {/* Contact Info + Socials */}
        <div className="space-y-4 mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div className="flex items-center">
              <Phone className="w-5 h-5 text-wl-green mr-4 flex-shrink-0" />
              <a href="tel:01923620240" className="text-white/80 hover:text-white transition-colors">
                01923 620240/41
              </a>
            </div>
            {/* Social Links */}
            <div className="flex items-center gap-4 justify-start sm:justify-end mt-2 sm:mt-0">
              <a
                href="https://twitter.com/wls_services/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className="hover:text-wl-green transition-colors"
              >
                <FaXTwitter className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100066219924205"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="hover:text-wl-green transition-colors"
              >
                <FaFacebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/whitefield-legal-services"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:text-wl-green transition-colors"
              >
                <FaLinkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/whitefieldlegalservices/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:text-wl-green transition-colors"
              >
                <FaInstagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          <div className="flex items-center">
            <Mail className="w-5 h-5 text-wl-green mr-4 flex-shrink-0" />
            <a href="mailto:admin@whitefieldlegal.com" className="text-white/80 hover:text-white transition-colors">
              admin@whitefieldlegal.com
            </a>
          </div>
          <div className="flex items-start">
            <MapPin className="w-5 h-5 text-wl-green mr-4 flex-shrink-0 mt-0.5" />
            <a 
              href="https://maps.app.goo.gl/HxETAUrLehR4nFg9A" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white transition-colors"
            >
              <div>2nd Floor Argyle House</div>
              <div>Joel Street, Northwood Hills</div>
              <div>HA6 1NW</div>
            </a>
          </div>
        </div>
        
        {/* Navigation Links */}
        <div className="text-center mb-8">
          <div className="text-white/80 text-sm">
            <a href="/about" className="hover:text-white transition-colors">About</a>
            <span className="mx-2">|</span>
            <a href="/contact" className="hover:text-white transition-colors">Contact</a>
            <span className="mx-2">|</span>
            <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
            <span className="mx-2">|</span>
            <a href="/terms" className="hover:text-white transition-colors">Terms and Conditions</a>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-6 text-center">
          <div className="text-white/60 text-xs mb-4">
            <span className="mr-4">Company Number: 06043320</span>
            <span>VAT Registration: 909511820</span>
          </div>
          <p className="text-white/60 text-sm">&copy; 2025 Whitefield Legal Services Limited. All rights reserved.</p>
          <p className="text-white text-sm"> Website by <a href="https://www.level5.life" className="hover:text-white underline transition-colors">Level 5</a></p>
        </div>
      </div>
    </footer>
  );
} 